import { Create, SimpleForm, TextInput } from "react-admin";

export function CreateSeo() {
  return (
    <Create>
      <SimpleForm>
        <TextInput source="slug" fullWidth />
        <TextInput source="title" fullWidth />
        <TextInput source="description" fullWidth multiline />
        <TextInput source="head" fullWidth multiline />
        <TextInput source="body" fullWidth multiline />
      </SimpleForm>
    </Create>
  );
}
